import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, resyncPush } from "@/lib/pushClient";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    registerServiceWorker().then(() => resyncPush());
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
